<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-coffee"></i> Comments</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Text:</label>
                  <div class="control">
                    <span>{{item.text}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Favorite:</label>
                    <div class="control">
                        <i class="fa fa-check has-text-success" v-if="item.favorite == true"></i>
                        <i class="fa fa-times has-text-danger" v-else></i>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Score:</label>
                    <div class="control">
                        <span>{{item.score}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12" v-if="item.user && item.user.profile">
                <div class="field">
                  <label class="label">Teacher:</label>
                  <div class="control">
                    <span>{{item.user.profile.name}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import CommentRepo from '../../repos/CommentRepo'
import lodash from 'lodash'

export default {
  name: 'comments-show',
  components: {},
  data() {
        return {
            repo: new CommentRepo(this.$auth),
            item: {},
        }
  },
  created(){  
    this.getUser(this.$route.params.id);
  },
  methods: {
    getUser(id){
        this.repo.show(id).then(response => {            
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/comments/Show.vue